module.exports = __webpack_public_path__ + "static/media/banner1.33e25394.svg";